export default class UnauthorizedController {
    // @ngInject
    constructor(urls) {
        this.helpUrl = urls.help;
    }
}
